import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useAuth } from "../../context/AuthContext";
import { db, collection, query, getDocs, orderBy } from "../../firebase";
import AdminLeftMenu from "./AdminLeftMenu";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import RealTimeUser from "./Charts/RealtimeUser";
import ActiveUsers from "./Charts/ActiveUsers";
import Sessions from "./Charts/Sessions";
import { useProductContext } from "../../context/ProductContext";
import ReactGA from "react-ga";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";

import GrowingChart1 from "./GrowingChart1";
import GrowingChart2 from "./GrowingChart2";
import AdminCheck from "./AdminCheck";

const AdminDashboard = () => {
  const { t, i18n } = useTranslation();
  const [progress, setProgress] = useState(true);
  const [KO_orders, setKO_orders] = useState([]);
  const [US_orders, setUS_orders] = useState([]);
  const [users, setUsers] = useState([]);

  const [numOfRecentUser, setNumOfRecentUser] = useState(0);
  const [revenue, setRevenue] = useState(null);
  const { currentUser } = useAuth();
  const { products } = useProductContext();
  // const [visitor, setVisitor] = useState(0);
  const [ipAddressTrack, setIpAddressTrack] = useState([]);
  const [productsInDB, setProductsInDB] = useState([]);
  const [productsOnSale, setProductsOnSale] = useState(0);
  const [productsStopped, setProductsStopped] = useState(0);

  useEffect(() => {
    setProductsInDB([]);
    setProductsStopped(0);
    setProductsOnSale(0);
    setKO_orders([]);
    setUsers([]);

    // getRevenue();
    console.log("ACESSS DB");

    getUsers();
    getOrders();
    getProductsInDB();
    // getVisitors();
    return () => {
      setKO_orders(null);
      setRevenue(null);
      setUsers(null);
      setNumOfRecentUser(null);
    };
  }, []);

  const getProductsInDB = async () => {
    const q = query(collection(db, "products"));
    const querySnapshot = await getDocs(q);

    querySnapshot.forEach(async (doc) => {
      setProductsInDB((old) => [...old, doc.data()]);

      if (doc.data().stop === "true") {
        setProductsStopped((count) => count + 1);
      } else {
        // console.log("false ===>", doc.data());
        // console.log(productsOnSale);
        setProductsOnSale((count) => count + 1);
      }
    });
  };
  // const getRevenue = async () => {
  //   const q = query(collection(db, "KO_orders"), orderBy("created", "asc"));
  //   const querySnapshot = await getDocs(q);
  //   let revenue = 0;
  //   querySnapshot.forEach(async (doc) => {
  //     revenue = revenue + +doc.data().finalPrice;
  //   });
  //   setRevenue(revenue.toFixed(2));
  // };
  const getOrders = async () => {
    const q2 = query(collection(db, "KO_orders"), orderBy("created", "desc"));

    const querySnapshot = await getDocs(q2);
    querySnapshot.forEach((doc2) => {
      // console.log(doc2.id, " => ", doc2.data());

      setKO_orders((old) =>
        old.concat({
          ...doc2.data(),
          id: doc2.id,
        })
      );
    });
    const q3 = query(collection(db, "US_orders"), orderBy("created", "desc"));

    const querySnapshot2 = await getDocs(q3);
    querySnapshot2.forEach((doc2) => {
      setUS_orders((old) =>
        old.concat({
          ...doc2.data(),
          id: doc2.id,
        })
      );
    });
  };
  const getUsers = async () => {
    const q = query(collection(db, "users"), orderBy("created", "desc"));

    let num = 0;
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // console.log(doc.id, " => ", doc.data());
      // if(doc.data()created?.toDate().toDateString())
      // console.log("Today month", new Date().getMonth());
      // console.log("DB Month", doc.data().created?.toDate().getMonth());

      // console.log("Today year", new Date().getFullYear());
      // console.log("DB year", doc.data().created?.toDate().getFullYear());
      if (
        new Date().getMonth() === doc.data().created?.toDate().getMonth() &&
        new Date().getFullYear() === doc.data().created?.toDate().getFullYear()
      ) {
        num = num + 1;
      }
      setUsers((old) =>
        old.concat({
          ...doc.data(),
          id: doc.id,
        })
      );
    });
    setNumOfRecentUser(num);
  };
  // console.log("ipAddressTrack", ipAddressTrack);

  // function recentUsers() {
  //   var rows = [];
  //   for (var i = 0; i < 5; i++) {
  //     rows.push(<br />);
  //     if (users[i]?.firstname)
  //       rows.push(
  //         <HashLink to="/admin/user">
  //           <span style={{ marginTop: "6px" }}>{users[i].firstname}</span>
  //         </HashLink>
  //       );
  //     if (users[i]?.lastname)
  //       rows.push(
  //         <HashLink to="/admin/user">
  //           {" "}
  //           <span style={{ marginTop: "6px" }}>{users[i].lastname}</span>
  //         </HashLink>
  //       );
  //   }
  //   return <div>{rows}</div>;
  // }

  useEffect(() => {
    setTimeout(() => {
      setProgress(false);
    }, 500);
  }, []);

  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9.5} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ fontSize: "16px", position: "relative", top: "+3px" }}
          >
            <Box sx={{ p: 3 }}>{t("Admin Account")}</Box>
            {/* <Box
              sx={{
                width: "100%",
                py: 3,
                borderTop: "1px solid lightgray",
                borderBottom: "1px solid lightgray",
                backgroundColor: "#d7e6f5",
                fontSize: "19px",
                px: 5,
                color: "#616161",
              }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: t(
                    "Our Heslet's 2022 Mission&nbsp;&nbsp;|&nbsp;&nbsp;Build & grow our business"
                  ),
                }}
              ></div>
            </Box> */}
          </Grid>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6" }}
          >
            <Box sx={{ py: 3, px: 3 }}>
              {/* Content */}
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "17px" }}>{t("Stats Overview")} </Box>
                <Box
                  className="pink_link"
                  sx={{ cursor: "pointer", fontSize: "13px" }}
                >
                  <HashLink to="/admin/stat">
                    {t("View Details Stats")}
                  </HashLink>
                </Box>
              </Box>
              <Box
                sx={{
                  mt: 2,
                  borderRadius: "2px",
                  display: "flex",
                  fontSize: "17px",
                }}
              >
                <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    backgroundColor: "white",
                    textAlign: "center",
                    p: { md: 4, sm: 1 },
                    py: 1,
                    position: "relative",
                    fontSize: "15px",
                  }}
                >
                  {t("New Users")}
                  <Box sx={{ fontSize: "37px", pt: 2 }}>{numOfRecentUser}</Box>
                  <Box
                    sx={{
                      color: "gray",
                      fontSize: "13px",
                      pt: 1,
                      position: "relative",
                      top: "+12px",
                    }}
                  >
                    {t("This Month2")}
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    borderLeft: "none",
                    backgroundColor: "white",
                    textAlign: "center",
                    p: { md: 4, sm: 1 },
                    py: 1,
                    fontSize: "15px",
                  }}
                >
                  {t("Products on sale")}
                  <Box sx={{ fontSize: "37px", pt: 2 }}>{productsOnSale}</Box>
                </Box>
                <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    borderLeft: "none",
                    backgroundColor: "white",
                    textAlign: "center",
                    p: { md: 4, sm: 1 },
                    py: 1,
                    position: "relative",
                    fontSize: "15px",
                  }}
                >
                  한국 주문 양
                  <Box sx={{ fontSize: "37px", pt: 2 }}>
                    {KO_orders?.length}
                  </Box>
                  <Box
                    sx={{
                      color: "gray",
                      fontSize: "13px",
                      pt: 1,
                    }}
                  >
                    {/* {t("This Month2")} */}
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    borderLeft: "none",
                    backgroundColor: "white",
                    textAlign: "center",
                    p: { md: 4, sm: 1 },
                    py: 1,
                    fontSize: "15px",
                  }}
                >
                  미국 주문 양
                  <Box sx={{ fontSize: "37px", pt: 2 }}>
                    {US_orders?.length}
                  </Box>
                  {/* <Box
                    sx={{
                      color: "gray",
                      fontSize: "13px",
                      pt: 1,
                      position: "relative",
                      top: "+12px",
                    }}
                  >
                    {t("This Month2")}
                  </Box> */}
                </Box>
              </Box>

              <GrowingChart1 />
              {/* <GrowingChart2 /> */}

              <Grid container>
                <Grid item md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",

                      mt: 3,
                      backgroundColor: "white",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "19px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ fontSize: "14px" }}>Website Analytics</Box>
                      <Box className="pink_link" sx={{ fontSize: "13px" }}>
                        <HashLink to="/admin/stat">
                          {t("View All Charts")}
                        </HashLink>
                      </Box>
                    </Box>
                    <Box sx={{ py: 2, px: 4 }}>
                      <Box>
                        <Sessions dashboard={true} />

                        <ActiveUsers dashboard={true} />
                        {/* <RealTimeUser /> */}
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Grid item md={6} sm={12} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      mr: { md: 5, sm: 0, xs: 0 },
                      backgroundColor: "white",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "19px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ fontSize: "15px", pt: "2px" }}>
                        한국 주문들
                      </Box>
                      <Box className="pink_link" sx={{ fontSize: "13px" }}>
                        <HashLink to="/admin/orders_ko#top">
                          {t("View Full Orders")}
                        </HashLink>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        py: 2,
                        px: 4,
                        minHeight: "300px",
                      }}
                    >
                      {KO_orders.map((order, idx) => {
                        if (idx < 4) {
                          // console.log("order", order);
                          return (
                            <Box
                              key={idx}
                              sx={{
                                pt: 1,
                                fontSize: "12px",
                                borderBottom: "1px solid lightgray",
                                paddingBottom: "6px",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                }}
                              >
                                <Box>
                                  주문 번호:{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    {order.id}
                                  </span>{" "}
                                </Box>
                                <span
                                  style={{
                                    color: "gray",
                                    fontSize: "13px",
                                    marginLeft: "4px",
                                  }}
                                >
                                  {order?.created &&
                                    order?.created
                                      ?.toDate()
                                      .toLocaleDateString("fr-CA", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                      })}{" "}
                                  {order?.created &&
                                    order?.created
                                      ?.toDate()
                                      .toLocaleTimeString("ko-KR")}{" "}
                                </span>
                              </Box>
                              <Box sx={{ pt: 1 }}>
                                이름:{" "}
                                <a
                                  href={"mailto:" + order.email}
                                  target="_blank"
                                  className="pink_link"
                                  rel="noreferrer"
                                >
                                  {order.address_lastname +
                                    order.address_firstname}
                                </a>
                                {", "}
                                배송 상태:{" "}
                                <span style={{ color: "green" }}>
                                  {t(order.status[order.status.length - 1])}
                                </span>
                              </Box>
                            </Box>
                          );
                        }
                      })}
                    </Box>
                  </Box>
                </Grid>{" "}
                <Grid item md={6} sm={12} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      ml: { md: 5, sm: 0, xs: 0 },
                      backgroundColor: "white",
                      minHeight: "390px",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "19px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box sx={{ fontSize: "15px", pt: "2px" }}>
                        새로 가입한 고객들
                      </Box>
                      <Box sx={{ display: "flex" }}>
                        <Box className="pink_link" sx={{ fontSize: "13px" }}>
                          <HashLink to="/admin/users_ko#top">
                            {t("View Korea Users")}
                          </HashLink>{" "}
                        </Box>
                        <Box
                          className="pink_link"
                          sx={{ fontSize: "13px", ml: 1 }}
                        >
                          <HashLink to="/admin/users_us#top">
                            {t("View US Users")}
                          </HashLink>
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{ py: 2, px: 4 }}>
                      {users.map((user, idx) => {
                        return (
                          <Box key={idx} sx={{ py: 1 }}>
                            <HashLink to={"/admin/user/" + user.id + "#top"}>
                              <span className="pink_link">
                                {user.lastname.toUpperCase()}&nbsp;
                                {user.firstname.toUpperCase()}
                              </span>
                            </HashLink>
                            &nbsp; (
                            <span style={{ color: "gray", fontSize: "13px" }}>
                              등록일&nbsp;
                              {user?.created
                                ?.toDate()
                                .toLocaleDateString("fr-CA", {
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                })}
                              {user.purchases &&
                                ", 구매 횟수:" + user.purchases?.length}
                            </span>
                            )
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              {/* End of Content */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminDashboard;
// users
